import axios from "axios";

// URL base leída desde variable de entorno.
// En local: .env → REACT_APP_API_URL=http://localhost:3001
// En CI/CD: build-arg → REACT_APP_API_URL=https://api-dev.vitalclic.com
const API_URL = process.env.REACT_APP_API_URL || "http://localhost:3001";

const axiosInstance = axios.create({
  baseURL: API_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

// Interceptor: adjunta el token JWT a cada petición automáticamente
axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error),
);

// Interceptor de respuesta: maneja errores globales de autenticación
axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      // Token inválido o expirado → limpiar sesión
      localStorage.removeItem("token");
      window.location.href = "/login";
    }
    return Promise.reject(error);
  },
);

export default axiosInstance;

// URL base exportada para los casos que usan fetch() en lugar de axios
export { API_URL };
